import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menus: [
      {
        name : 'Ev',
        icon : 'icofont-ui-home',
        to : '/',
        roles : ['Admin', 'Partner']
      },
      {
        name: 'Bulk SMS',
        icon: 'icofont-ui-message',
        to: '/bulksms',
        roles: ['Admin', 'Partner']
      },
      {
        name: 'Sms Şablon',
        icon: 'icofont-ui-message',
        to: '/messageTemplates',
        roles: ['Admin', 'Partner']
      },
      {
        name: 'Sms Şablon Status',
        icon: 'icofont-ui-message',
        to: '/smsShablonStatus',
        roles: ['Admin']
      },
      {
        name: 'Sms Qrup',
        icon: 'icofont-ui-user-group',
        to: '/smsgroups',
        roles: ['Admin', 'Partner']
      },
      // {
      //   name: 'GeneralPartners',
      //   icon: 'icofont-ui-user-group',
      //   to: '/generalpartners',
      //   roles: ['Admin', 'superadmin']
      // },
      // {
      //   name: 'ProcessingPartners',
      //   icon: 'icofont-ui-user-group',
      //   to: '/processingpartners',
      //   roles: ['Admin', 'superadmin']
      // },
      // {
      //   name: 'ReceivingPartners',
      //   icon: 'icofont-ui-user-group',
      //   to: '/ReceivingPartners',
      //   roles: ['Admin', 'superadmin']
      // },
      {
        name: 'Statistika',
        icon: 'icofont-bank',
        to: '/Report',
        roles: ['Admin', 'Partner']
      },
      {
        name: 'İstifadəçilər',
        icon: 'icofont-ui-user',
        to: '/users',
        roles: ['Admin']
      }, 
    ],
    timestamps: [
      '09:00', '09:30', 
      '10:00', '10:30', 
      '11:00', '11:30',
      '12:00', '12:30',
      '13:00', '13:30',
      '14:00', '14:30',
      '15:00', '15:30',
      '16:00', '16:30',
      '17:00', '17:30',
      '18:00', '18:30',
    ],
    durations: [
      '0:30', '1:00',
      '1:30', '2:00',
      '2:30', '3:00',
      '3:30', '4:00',
      '4:30', '5:00',
      '5:30', '6:00',
      '6:30', '7:00',
      '7:30', '8:00',
      '8:30', '9:00',
      '9:30', '10:00',
    ],
    templateTypes: [
      'Yaratma',
      'Dəyişmə',
      'Silinmə',
      'Xatırlama'
    ]
  },

  getters: {
    getMenus(state){
      return state.menus
    },
    getTimestamps(state) {
      return state.timestamps
    },
    getDurations(state) {
      return state.durations
    },
    getTemplateTypes(state) {
      return state.templateTypes
    }
  }
});